import { getItem } from "utils/local-storage";
import { ACCESS_TOKEN } from "utils/storage-keys";
import { doGet, doGetClubsServer } from "./common";

export async function getAchievement(accessToken: string | null) {
  const url = `user/api/v2/account/achievement`;
  if (accessToken) {
    return doGet<any, any>(
      url,
      {},
      {
        'X-Session-Token': accessToken
      }
    );
  }
}

export async function getLeaderBoard(userId: string) {
  if (userId) {
    const url = `clubs-server/v1/leaderboards/global/${userId}`;
    const accessToken = getItem(ACCESS_TOKEN);
    if (accessToken) {
      return doGetClubsServer<any, any>(
        url,
        {},
        {
          'X-Session-Token': accessToken
        }
      );
    }
  }
}

export async function getStateInformation(accessToken: string | null) {
  const url = `user/api/v2/account/state`;
  if (accessToken) {
    return doGet<any, any>(
      url,
      {},
      {
        'X-Session-Token': accessToken
      }
    );
  }
}
